import Vue from 'vue';
import VueRouter, { Route } from 'vue-router';

import { tokenName } from '@/use/useAuth';

import Login from '@/views/Login.vue';
import Logout from '@/views/Logout.vue';

import AppPanicom from '@/views/AppPanicom.vue';

import Dashboard from '@/views/Dashboard/Index.vue';
import DynamicDashboard from '@/views/Dashboard/DynamicDashboard.vue';
import SaleDashboard from '@/views/Dashboard/SaleDashboard.vue';

import StoreIndex from '@/views/Store/Index.vue';
import StorePartList from '@/views/Material/List.vue';
import StoreReceiveList from '@/views/Store/ReceiveMaterialList.vue';
import StoreQCList from '@/views/Store/StoreQc.vue';

import MaterialIndex from '@/views/Material/Index.vue';
import MaterialCreate from '@/views/Material/Create.vue';
import MaterialCategory from '@/views/Material/Category.vue';
import MaterialEdit from '@/views/Material/Edit.vue';
import MaterialDetail from '@/views/Material/Detail.vue';

import PurchaseRequestIndex from '@/views/PurchaseRequest/Index.vue';
import PurchaseRequestList from '@/views/PurchaseRequest/List.vue';
import PurchaseRequestCreate from '@/views/PurchaseRequest/Create.vue';
import PurchaseRequestCreateProduction from '@/views/PurchaseRequest/CreateProduction.vue';
import PurchaseRequestCreateMisc from '@/views/PurchaseRequest/CreateMisc.vue';
import PurchaseRequestCreateTreatment from '@/views/PurchaseRequest/CreateTreatment.vue';
import PurchaseRequestReceive from '@/views/PurchaseRequest/Receive.vue';

// import FinishStoreAddP from '@/views/Store/FinishAddPart.vue';
import PurchaseOrderIndex from '@/views/PurchaseOrder/Index.vue';
import PurchaseOrderList from '@/views/PurchaseOrder/List.vue';
import PurchaseOrderCreateIndex from '@/views/PurchaseOrder/CreateIndex.vue';
import PurchaseOrderCreate from '@/views/PurchaseOrder/Create.vue';
import PurchaseOrderEdit from '@/views/PurchaseOrder/Edit.vue';
import PurchaseOrderHistory from '@/views/PurchaseOrder/History.vue';
import PurchaseOrderReceive from '@/views/PurchaseOrder/Receive.vue';
import PurchaseOrderLog from '@/views/PurchaseOrder/Log.vue';

import JobIndex from '@/views/Job/Index.vue';
import JobList from '@/views/Job/List.vue';
import JobCreate from '@/views/Job/Create.vue';
import JobEdit from '@/views/Job/Edit.vue';
import JobDetail from '@/views/Job/Detail.vue';
import JobAssembly from '@/views/Job/Assembly.vue';

import SubJobList from '@/views/Job/SubJobList.vue';
import SubJobQCList from '@/views/Job/QCSubJob.vue';

import SupplierIndex from '@/views/Supplier/Index.vue';
import SupplierList from '@/views/Supplier/SupplierList.vue';
import SupplierCreate from '@/views/Supplier/Create.vue';
import SupplierEdit from '@/views/Supplier/Edit.vue';

import CustomerIndex from '@/views/Customer/Index.vue';
import CustomerList from '@/views/Customer/List.vue';
import CustomerCreate from '@/views/Customer/Create.vue';
import CustomerEdit from '@/views/Customer/Edit.vue';

import WithdrawIndex from '@/views/Withdraw/Index.vue';
import ReturnList from '@/views/Withdraw/ListReturn.vue';
import WithdrawList from '@/views/Withdraw/ListWithdraw.vue';

import WithdrawCreateIndex from '@/views/Withdraw/Create.vue';
import WithdrawCreate from '@/views/Withdraw/Withdraw.vue';
import DepositCreate from '@/views/Withdraw/Deposit.vue';
import WithdrawUpdate from '@/views/Withdraw/Update.vue';
import WithdrawConfirm from '@/views/Withdraw/Confirm.vue';

import SettingIndex from '@/views/Setting/Index.vue';
import SettingSupplier from '@/views/Setting/System/Supplier.vue';
import SettingStockLocation from '@/views/Setting/System/StockLocation.vue';

import UserIndex from '@/views/Setting/User/Index.vue';
import UserList from '@/views/Setting/User/List.vue';
import UserCreate from '@/views/Setting/User/New.vue';
import UserEdit from '@/views/Setting/User/Edit.vue';

import NotifyIndex from '@/views/Setting/Notify/Index.vue';
import NotifyNew from '@/views/Setting/Notify/New.vue';
import NotifyEdit from '@/views/Setting/Notify/Edit.vue';

import ProfileIndex from '@/views/Profile/Index.vue';
import Profile from '@/views/Profile/Profile.vue';

import Error from '../views/Error.vue';

Vue.use(VueRouter);

const guardAuth = async (to: Route, from: Route, next: (route?: any) => void) => {
  if (localStorage.getItem(tokenName) || sessionStorage.getItem(tokenName)) {
    next(); // TODO: implement token expire check
  } else {
    next({ name: 'Login' });
  }
};

const routes = [
  { // when from: login single field, provide company logo unless main domain
    path: '/',
    name: 'Login',
    component: Login,
  },
  {
    path: '/logout',
    name: 'Logout',
    component: Logout,
  },
  // TODO: Fix this   :(
  // {
  //   path: '/StoreAddPart/FinishStoreAddPart',
  //   name: 'FinishStoreAddPart',
  //   component: FinishStoreAddPart,
  // },
  {
    path: '/app',
    beforeEnter: guardAuth, // Check only root, no need to check children
    component: AppPanicom,
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: Dashboard,
      },
      {
        path: 'dashboard-purchase',
        name: 'DashboardPurchase',
        component: DynamicDashboard,
        meta: { component: 'PurchaseDashboard' },
      },
      {
        path: 'dashboard-production',
        name: 'DashboardProduction',
        component: DynamicDashboard,
        meta: { component: 'ProductionDashboard' },
      },
      {
        path: 'dashboard-store',
        name: 'DashboardStore',
        component: DynamicDashboard,
        meta: { component: 'StoreDashboard' },
      },
      {
        path: 'store',
        component: StoreIndex,
        children: [
          {
            path: '',
            name: 'StorePartList',
            component: StorePartList,
          },
          {
            path: 'receive',
            name: 'StoreReceivePartList',
            component: StoreReceiveList,
          },
          {
            path: 'qc/:bomId',
            name: 'StoreQCList',
            component: StoreQCList,
          },
          {
            path: 'qc',
            name: 'StoreQCIndex',
            component: StoreQCList,
          },
        ],
      },
      {
        path: 'material',
        component: MaterialIndex,
        children: [
          {
            path: 'create',
            name: 'MaterialCreate',
            component: MaterialCreate,
          },
          {
            path: 'category',
            name: 'MaterialCategory',
            component: MaterialCategory,
          },
          {
            path: ':id',
            name: 'MaterialDetail',
            component: MaterialDetail,
          },
          {
            path: ':id/edit',
            name: 'MaterialEdit',
            component: MaterialEdit,
          },
        ],
      },
      {
        path: 'pr',
        component: PurchaseRequestIndex,
        children: [
          {
            path: '',
            name: 'PurchaseRequestList',
            component: PurchaseRequestList,
          },
          {
            path: 'treatment',
            name: 'PurchaseRequestCreateTreatment',
            component: PurchaseRequestCreateTreatment,
          },
          {
            path: 'receive',
            name: 'PurchaseRequestReceive',
            component: PurchaseRequestReceive,
          },
          {
            path: 'create',
            name: 'PurchaseRequestCreate',
            component: PurchaseRequestCreate,
            children: [
              {
                path: 'production',
                name: 'PurchaseRequestCreateProduction',
                component: PurchaseRequestCreateProduction,
              },
              {
                path: 'misc',
                name: 'PurchaseRequestCreateMisc',
                component: PurchaseRequestCreateMisc,
              },
              {
                path: 'production/:bomId',
                name: 'PurchaseRequestCreateProductionWithBomId',
                component: PurchaseRequestCreateProduction,
              },
            ],
          },
        ],
      },
      // Purchase Order
      {
        path: 'po',
        component: PurchaseOrderIndex,
        children: [
          {
            path: '',
            name: 'PurchaseOrderList',
            component: PurchaseOrderList,
          },
          {
            path: 'create',
            name: 'PurchaseOrderCreateIndex',
            component: PurchaseOrderCreateIndex,
            children: [
              {
                path: '',
                name: 'PurchaseOrderCreateWithoutId',
                component: PurchaseOrderCreate,
              },
              {
                path: ':prId',
                name: 'PurchaseOrderCreate',
                component: PurchaseOrderCreate,
              },
            ],
          },
          {
            path: ':poId',
            component: PurchaseOrderIndex,
            children: [
              {
                path: 'receive',
                name: 'PurchaseOrderReceive',
                component: PurchaseOrderReceive,
              },
              {
                path: 'log',
                name: 'PurchaseOrderLog',
                component: PurchaseOrderLog,
              },
              {
                path: 'edit',
                name: 'PurchaseOrderEdit',
                component: PurchaseOrderEdit,
              },
            ],
          },
          {
            path: 'history',
            name: 'PurchaseOrderHistory',
            component: PurchaseOrderHistory,
          },
        ],
      },
      {
        path: 'job',
        component: JobIndex,
        redirect: { name: 'JobList' },
        children: [
          {
            path: '',
            name: 'JobList',
            component: SaleDashboard,
          },
          {
            path: 'subjob',
            name: 'SubJobList',
            component: SubJobList,
          },
          {
            path: 'qc-job',
            name: 'SubJobQCList',
            component: SubJobQCList,
          },
          {
            path: 'new',
            name: 'JobCreate',
            component: JobCreate,
          },
          {
            path: ':id/edit',
            name: 'JobEdit',
            component: JobEdit,
          },
          {
            path: ':id/assembly',
            name: 'JobAssembly',
            component: JobAssembly,
          },
          {
            path: ':id',
            name: 'JobDetail',
            component: JobDetail,
          },
        ],
      },
      {
        path: 'supplier',
        component: SupplierIndex,
        children: [
          {
            path: '',
            name: 'SupplierList',
            component: SupplierList,
          },
          {
            path: 'new',
            name: 'SupplierCreate',
            component: SupplierCreate,
          },
          {
            path: ':id',
            name: 'SupplierEdit',
            component: SupplierEdit,
          },
        ],
      },
      {
        path: 'customer',
        component: CustomerIndex,
        children: [
          {
            path: '',
            name: 'CustomerList',
            component: CustomerList,
          },
          {
            path: 'new',
            name: 'CustomerCreate',
            component: CustomerCreate,
          },
          {
            path: ':id',
            name: 'CustomerEdit',
            component: CustomerEdit,
          },
        ],
      },
      {
        path: 'withdraw',
        component: WithdrawIndex,
        children: [
          {
            path: '',
            name: 'WithdrawList',
            component: WithdrawList,
          },
          {
            path: 'deposit',
            name: 'ReturnList',
            component: ReturnList,
          },
          {
            path: ':id/confirm',
            name: 'WithdrawConfirm',
            component: WithdrawConfirm,
          },
          {
            path: ':id',
            name: 'WithdrawUpdate',
            component: WithdrawUpdate,
          },
          {
            path: 'create',
            component: WithdrawCreateIndex,
            children: [
              {
                path: 'deposit',
                name: 'DepositCreate',
                component: DepositCreate,
              },
              {
                path: 'deposit/:bomId',
                name: 'DepositCreateWithBomId',
                component: DepositCreate,
              },
              {
                path: '',
                name: 'WithdrawCreate',
                component: WithdrawCreate,
              },
              {
                path: ':bomId',
                name: 'WithdrawCreateWithBomId',
                component: WithdrawCreate,
              },
            ],
          },
        ],
      },
      {
        path: 'setting',
        name: 'SettingIndex',
        component: SettingIndex,
        children: [
          {
            path: 'supplier',
            name: 'SettingSupplier',
            component: SettingSupplier,
          },
          {
            path: 'stock-location',
            name: 'SettingStockLocation',
            component: SettingStockLocation,
          },
          {
            path: 'user',
            component: UserIndex,
            name: 'SettingUserList',
            children: [
              {
                path: ':roleId',
                name: 'UserList',
                component: UserList,
              },
              {
                path: ':roleId/create',
                name: 'SettingUserCreate',
                component: UserCreate,
              },
              {
                path: 'edit/:id',
                name: 'SettingUserEdit',
                component: UserEdit,
              },
            ],
          },
          {
            path: 'notify',
            component: NotifyIndex,
            name: 'NotifyIndex',
            children: [
              {
                path: 'new',
                name: 'NotifyNew',
                component: NotifyNew,
              },
              {
                path: ':id/edit',
                name: 'NotifyEdit',
                component: NotifyEdit,
              },
            ],
          },
        ],
      },
      {
        path: 'profile',
        name: 'ProfileIndex',
        component: ProfileIndex,
        children: [
          {
            path: '',
            name: 'Profile',
            component: Profile,
          },
        ],
      },
    ],
  },
  { path: '*', component: Error },
];

const router = new VueRouter({
  routes,
});

export default router;
